/* eslint-disable import/no-anonymous-default-export */
import { VALIDATE_DELEGATES, RESET_DELEGATES } from "../actions/types";
const initialState = [];

const interconexionReducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VALIDATE_DELEGATES:
      return {
        ...state,
        isValidDelegate: payload,
      };
    case RESET_DELEGATES:
      return {
        ...state,
        isValidDelegate: payload,
      };
    default:
      return state;
  }
};

export default interconexionReducer;
